import React, { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { useFormik } from "formik";
import * as Yup from "yup";

import { getBase64 } from "../../../../utils/encodeimage";
import { useThemeChange } from "../../../../utils/themeChange";
import useAuthStore from "../../../../store/authStore";
import { useApi } from "../../../../hooks/api/useApi";
import { useToastContext } from "../../../../modules/toast/context";
import { USER } from "../../../../constants/api-constants";

import Loading from "../../../../components/components/Loading";

const EditProfile = function () {
  const themeChange = useThemeChange();
  const { userData, addUser } = useAuthStore((state) => ({
    userData: state.userLog,
    addUser: state.addUser,
  }));
  const { patch } = useApi();
  const { showError, showSuccess } = useToastContext();
  const [profileImage, setProfileImage] = useState("");
  const [profile, setProfile] = useState("");

  const phoneRegExp =
    /^((\+[1-9]{1,4}[ \\-])|(\([0-9]{2,3}\)[ \\-])|([0-9]{2,4})[ \\-]*)?[0-9]{10}$/;
  const nameRegex = /^[A-Za-z ]+$/;

  const formik = useFormik({
    initialValues: {
      firstName: userData?.firstName,
      lastName: userData?.lastName,
      website: userData?.website,
      contactNumber: userData?.contactNumber,
    },
    validationSchema: Yup.object({
      firstName: Yup.string()
        .matches(nameRegex, "Invalid Name. Can only contain letters.")
        .required(" required*"),
      lastName: Yup.string()
        .matches(nameRegex, "Invalid Name. Can only contain letters.")
        .required(" required*"),
      website: Yup.string().url("Invalid URL").required("required*"),
      contactNumber: Yup.string().matches(
        phoneRegExp,
        "Invalid contact number"
      ),
    }),
  });

  const updateProfile = useMutation({
    mutationFn: patch,
    onSuccess: (data) => {
      addUser(data);
      showSuccess("Profile updated successfully.");
    },
    onError: () => {
      showError("Profile update failed");
    },
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const mutationData = {
      ...formik.values,
      // name: formik.values.firstName.concat(" ", formik.values.lastName),
      route: USER.UPDATE_PROFILE,
      access_token: userData?.access_token,
      id: userData?.id,
    };

    if (!userData?.profileImage) {
      mutationData.profileImage = profile;
    }

    if (userData?.profileImage && profile) {
      mutationData.profileImage = profile;
    }

    updateProfile.mutate(mutationData);
  };
  const preventMinus = (e) => {
    if (e.code === "Minus") {
      e.preventDefault();
    }
  };
  return (
    <div className={themeChange.add("section")}>
      <>
        <section className="jumbotron breadcumb no-bg">
          <div className="mainbreadcumb">
            <div className="container">
              <div className="row m-10-hor">
                <div className="col-12">
                  <h1 className="text-center">Edit Profile</h1>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="container">
          <form
            id="form-create-item"
            className="form-border"
            action=""
            onSubmit={handleSubmit}
          >
            <div className="row mb-5">
              <div className="col-md-8 col-sm-12">
                <div className="field-set">
                  <div className="d-flex gap-2 flex-wrap">
                    <h5>First Name :</h5>
                    {formik.touched.firstName && formik.errors.firstName ? (
                      <span className="error-message-color">
                        {formik.errors.firstName}
                      </span>
                    ) : null}
                  </div>
                  <input
                    type="text"
                    name="firstName"
                    id="firstName"
                    className="form-control"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.firstName}
                  />

                  <div className="spacer-10"></div>
                  <div className="d-flex gap-2 flex-wrap">
                    <h5>Last Name :</h5>
                    {formik.touched.lastName && formik.errors.lastName ? (
                      <span className="error-message-color">
                        {formik.errors.lastName}
                      </span>
                    ) : null}
                  </div>
                  <input
                    type="text"
                    name="lastName"
                    id="lastName"
                    className="form-control"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.lastName}
                  />

                  <div className="spacer-10"></div>
                  <h5>Email Address :</h5>
                  <input
                    type="email"
                    name="email"
                    id="email"
                    className="form-control"
                    defaultValue={userData?.email}
                    disabled
                  />

                  <div className="spacer-10"></div>
                  <div className="d-flex gap-2 flex-wrap">
                    <h5>Website :</h5>
                    {formik.touched.website && formik.errors.website ? (
                      <span className="error-message-color">
                        {formik.errors.website}
                      </span>
                    ) : null}
                  </div>
                  <input
                    type="url"
                    name="website"
                    id="website"
                    className="form-control"
                    placeholder="e.g. https://example.com"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.website}
                  />

                  <div className="spacer-10"></div>
                  <div className="d-flex gap-2 flex-wrap">
                    <h5>Phone :</h5>
                    {formik.touched.contactNumber &&
                    formik.errors.contactNumber ? (
                      <span className="error-message-color">
                        {formik.errors.contactNumber}
                      </span>
                    ) : null}
                  </div>
                  <input
                    type="text"
                    min={0}
                    name="contactNumber"
                    id="contactNumber"
                    className="form-control"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.contactNumber}
                    onKeyPress={preventMinus}
                  />

                  <div className="spacer-10"></div>
                  <h5>Username :</h5>
                  <input
                    type="text"
                    name="username"
                    id="username"
                    className="form-control"
                    defaultValue={userData?.username}
                    disabled
                  />
                </div>
              </div>
              <div className="col-md-4 col-sm-12">
                <div>
                  <h5>Profile Picture</h5>

                  <div className="d-create-file">
                    {userData?.profileImage || profileImage.length ? (
                      <img
                        id="close"
                        src={
                          profileImage.length
                            ? profileImage
                            : userData?.profileImage
                        }
                        alt=""
                        height={200}
                        width={200}
                        style={{ marginBottom: "30px" }}
                      />
                    ) : (
                      <>
                        <p key="{index}">PNG or JPG</p>
                      </>
                    )}
                    <div className="browse">
                      <input
                        type="button"
                        id="get_file"
                        className="btn-main"
                        value="Browse"
                      />
                      <input
                        id="upload_file"
                        type="file"
                        name="profileImage"
                        onChange={(e) => {
                          const imgSize = e.target.files[0].size;
                          if (imgSize > 5 * 1024 * 1024) {
                            showError("Image size should be less than 5MB");
                            return;
                          }
                          setProfileImage(
                            URL.createObjectURL(e.target.files[0])
                          );
                          getBase64(e.target.files[0], setProfile);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="spacer-single"></div>
              {updateProfile.isLoading ? (
                <Loading loadingMessage="Updating your Profile" />
              ) : (
                <input
                  type="submit"
                  id="submit"
                  className="btn btn-main color-2"
                  value="Update Profile"
                  style={{ marginLeft: "20px" }}
                  disabled={!(formik.dirty && formik.isValid)}
                />
              )}
            </div>
          </form>
        </section>
      </>
    </div>
  );
};

export default EditProfile;
